import { ApolloProvider } from '@apollo/client/react';
import { AutoLinkContext } from '@betterment/js-runtime';
import { RouterProvider, RouterProviderProps, createBrowserRouter } from 'react-router-dom';

import NotFound from '~/b4b/components/not-found/NotFound';
import { client } from '~/b4b/graphql/client';
import { CurrentEmployerContext } from '~/b4b/utils/currentEmployer';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { Root } from './Root';
import { routes } from './routes';

import { TestTrackProvider } from '../test-track/hooks';
import { startTestTrack } from '../test-track/testTrack';

const testTrackPromise = startTestTrack();

type Props = {
  employerId: string;
  router: RouterProviderProps['router'];
};

export const createRouter = (): RouterProviderProps['router'] =>
  createBrowserRouter(
    [
      {
        path: '/',
        element: <Root />,
        children: [...routes, { path: '*', element: <NotFound /> }],
      },
    ],
    { basename: urlBuilder.appHome.absolute() }
  );

const autoLinkContextValue = { basename: '', routes };

/**
 * Main SPA application component for B4B.
 * Provides routing, providers, and layout for the SPA pages.
 */
export const App: React.FC<Props> = ({ router, employerId }) => {
  return (
    <AutoLinkContext.Provider value={autoLinkContextValue}>
      <ApolloProvider client={client}>
        <CurrentEmployerContext.Provider value={employerId}>
          <TestTrackProvider value={testTrackPromise}>
            <RouterProvider router={router} />
          </TestTrackProvider>
        </CurrentEmployerContext.Provider>
      </ApolloProvider>
    </AutoLinkContext.Provider>
  );
};
